// Shared inner body for the Oscar account product-alerts list page. Renders
// inside AccountPageBody (the account side-nav shell) without the document
// chrome -- each site wraps this in its own PageSkeleton so the DOM is
// byte-identical to the pre-move AccountPageShell.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountPageBody } from "../AccountPageBody";

type IProps = Immutable<templates.ProductAlertListDocumentTemplate>;

export const ProductAlertListBody = (props: IProps): React.JSX.Element => {
    const {
        alerts,
        empty_message,
        product_header_label,
        status_header_label,
        date_created_header_label,
        cancel_label,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            {alerts.length > 0 ? (
                <form method="post" id="alerts_form">
                    <CSRFToken />
                    <table className="table table-striped table-bordered">
                        <tbody>
                            <tr>
                                <th>{product_header_label}</th>
                                <th>{status_header_label}</th>
                                <th>{date_created_header_label}</th>
                                <th></th>
                            </tr>
                            {alerts.map((alert, i) => (
                                <tr key={i}>
                                    <td>
                                        {alert.is_public ? (
                                            <a href={alert.product_url}>
                                                {alert.title}
                                            </a>
                                        ) : (
                                            alert.title
                                        )}
                                    </td>
                                    <td>{alert.status}</td>
                                    <td>{alert.date_created}</td>
                                    <td>
                                        {alert.cancel_url && (
                                            <a
                                                href={alert.cancel_url}
                                                className="btn btn-danger"
                                            >
                                                {cancel_label}
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </form>
            ) : (
                <p>{empty_message}</p>
            )}
        </AccountPageBody>
    );
};
